export const competenceAssessmentKeys = {
  all: ['competenceAssessment'],

  lists: () => [...competenceAssessmentKeys.all, 'list'],

  adminList: (enabledFlag: boolean) => [...competenceAssessmentKeys.lists(), 'admin', enabledFlag],

  teacherList: (classId?: number) => [...competenceAssessmentKeys.lists(), 'teacher', classId ?? null],
};
